import { render, staticRenderFns } from "./FormGroupAddressInfoV2.vue?vue&type=template&id=9457ff16&scoped=true"
import script from "./FormGroupAddressInfoV2.vue?vue&type=script&lang=js"
export * from "./FormGroupAddressInfoV2.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9457ff16",
  null
  
)

export default component.exports